import ApiBase from './api-base'
import kameleoon from '@/modules/services/kameleoon'
import * as DataFormatter from '@/components/checkout-v3/api/data-formatter'
import * as Bugsnag from '@/modules/services/bugsnag'
import { routes } from '@/modules/config/api'

export const BFF_GLOBAL_CONFIG_FLAG = 'enable_bff_global_config'

class GlobalConfig extends ApiBase {
  async fetch () {
    try {
      const { data } = await this.client.get(this.url, this.requestConfig)
      return {
        success: true,
        data: DataFormatter.format(data)
      }
    } catch (e) {
      Bugsnag.notifyBugsnag(e)
      return { success: false, data: null, message: e.message }
    }
  }
}

export class LuxolaGlobalConfig extends GlobalConfig {
  constructor () {
    super()

    this.url = '/internal_api/global_config'
    this.requestConfig = { baseURL: routes.baseURL }
  }
}

export class BffGlobalConfig extends GlobalConfig {
  constructor () {
    super()

    // Requests with the X-SWA header are routed to the BFF (SWA)
    this.url = '/web/v1/global-config'
    // basePath stays in baseURL as the interceptor strips the /api/ prefix from the url
    this.requestConfig = {
      baseURL: `${routes.bffBaseURL}${routes.basePath}`,
      headers: {
        'X-SWA': 'web',
        'Accept-Language': this.client.defaults.headers['Accept-Language'],
        'X-Site-Country': this.client.defaults.headers['X-Site-Country']
      }
    }
  }
}

const isBffEnabled = async () => {
  try {
    return !!(await kameleoon.isFeatureFlagActive(BFF_GLOBAL_CONFIG_FLAG))
  } catch (e) {
    return false
  }
}

// Picks the source on every fetch, as Kameleoon SDK may not be ready at instantiation
class GlobalConfigService {
  async fetch () {
    const globalConfigApi = await isBffEnabled() ? new BffGlobalConfig() : new LuxolaGlobalConfig()
    return globalConfigApi.fetch()
  }
}

export default GlobalConfigService
